import RCTooltip from 'rc-tooltip';
import React, { PureComponent } from 'react';
import { isEmpty2 } from '../../common/utils';

class Tooltip extends PureComponent {

    constructor(props) {
        super(props);
        this.emptyClick = this.emptyClick.bind(this);
    }

    emptyClick = () => {

    }

    render() {
        const tooltipText = this.props.hideTooltip ? '' : this.props.text;
        if (this.props.visible === undefined) {
            return (
                <RCTooltip id={this.props.id} placement={this.props.place ? this.props.place : 'bottom'}
                    //destroyTooltipOnHide={true}
                    align={this.props.align ? this.props.align : ({ offset: [0, 0] })}
                    mouseLeaveDelay={0}
                    overlayClassName={isEmpty2(tooltipText) ? 'rc-tooltip-hidden' : (this.props.overlayClassName ? this.props.overlayClassName : '')}
                    afterVisibleChange={this.props.afterVisibleChange ? this.props.afterVisibleChange : this.emptyClick}
                    overlay={
                        <div className='mxwd500 v-word-break'>
                            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left', lineHeight: 1.2 }}>
                                {tooltipText}
                            </div>
                        </div>
                    }
                >
                    {this.props.children}
                </RCTooltip>
            )
        } else {
            return (
                <RCTooltip id={this.props.id} placement={this.props.place ? this.props.place : 'bottom'}
                    visible={this.props.visible}
                    //destroyTooltipOnHide={true}
                    align={this.props.align ? this.props.align : ({ offset: [0, 0] })}
                    mouseLeaveDelay={0}
                    overlayClassName={isEmpty2(tooltipText) ? 'rc-tooltip-hidden' : (this.props.overlayClassName ? this.props.overlayClassName : '')}
                    afterVisibleChange={this.props.afterVisibleChange ? this.props.afterVisibleChange : this.emptyClick}
                    overlay={
                        <div className='mxwd500 v-word-break'>
                            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left', lineHeight: 1.2 }}>
                                {tooltipText}
                            </div>
                        </div>
                    }
                >
                    {this.props.children}
                </RCTooltip>
            )
        }
    }
}

export default Tooltip;
